import { IDropdownOption } from "@fluentui/react";

import React,{ useEffect } from "react";
import { fetchActuationTypes } from "../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { mapIDescriptionToDropDownOptions, mapIDescriptionToDropDownWithCustomOptions } from "../../../../../utils";
import { ControlledDropdown } from "../../../../common/selectors";
import { IBaseSelectorProps } from "../IBaseSelectorProps";

interface ISelectorActuationTypesProps {	
    noneOption?: boolean;
    optionString?: string;
}

export const ActuationTypesSelector: React.FC<IBaseSelectorProps & ISelectorActuationTypesProps> = ({ onChange, selectedKey, propertyName, title, disabled, isRequired, control, rules, noneOption, optionString }) => {
    const { data, loading } = useAppSelector(store => store.catalog.actuationTypes);
    const dispatch = useAppDispatch();

    useEffect(() => {
        data.length === 0 && dispatch(fetchActuationTypes());
    }, [dispatch, data]);



    const onSelectorChange = (_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        onChange(option, propertyName);
    };

    return (
        <ControlledDropdown
            onChange={onSelectorChange}
            selectedKey={selectedKey}
            options={noneOption ? mapIDescriptionToDropDownWithCustomOptions(data, optionString ?? "") : mapIDescriptionToDropDownOptions(data)}
            disabled={loading || disabled}
            label={title}
            name={propertyName}
            required={isRequired}
            control={control}
            rules={rules}
        />
    );
};
